import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  CircularProgress,
  Grid,
  LinearProgress,
  Pagination,
  Typography,
} from "@mui/material";

import promotionCard from "@/assets/promotionCard.svg";
import promotionFirst from "@/assets/promotionFirst.png";
import { useNavigate } from "react-router-dom";
import promotionSecond from "@/assets/promotionSecond.png";
import HomeScreenImg from "@/assets/earth.jpg";
import { UsePromotionByReferList } from "../api/getPromotionByRefer";
import { UsePromotionByBuyList } from "../api/getPromotionByBuy";
import { useAuth } from "@/lib/auth";
import storage from "@/utils/storage";
import axios from "axios";
import Header from "@/components/Elements/header";
import HeaderValue from "@/components/Elements/headerMain";
import Footer from "@/components/Elements/footer";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
  paperClass: {
    padding: theme.spacing(2),
    textAlign: "center",
    background: "rgba(5, 5, 24, 0.8)",
    borderRadius: "10px",
  },

  myGridItem: {
    backgroundColor: "rgba(5, 5, 24, 0.8)",
    padding: "30px",
    borderRadius: "20px",
  },
  innerGrid: {
    backgroundColor: "#050518",
    padding: "10px",
    borderRadius: "20px",
  },
  innerGridFirst: {
    background: `url(${promotionFirst})`,
    backgroundRepeat: "no-repeat",
    height: "auto",
    width: "auto",
    minHeight: "282px",
    minWidth: "282px",
    backgroundPosition: "left bottom",
  },
  innerGridSecond: {
    backgroundColor: "#050518",
    padding: "10px",
    borderRadius: "20px",
  },
  innerGridThird: {
    background: `url(${promotionSecond})`,
    backgroundRepeat: "no-repeat",
    height: "auto",
    width: "auto",
    minHeight: "282px",
    minWidth: "282px",
    backgroundPosition: "center",
  },
  cardRoot: {
    background: "rgba(5, 5, 24, 1)",
    boxShadow: "0px 2.81226px 28.1226px 7.03066px rgba(0, 0, 0, 0.03)",
    borderRadius: "10px",
  },
}));
interface PromotionResponse {
  message: string;
  data: Promotion[]; // Array of promotion objects
  pagination: {
    totalItems: number;
    totalPages: number;
    itemsPerPage: number;
  };
}

interface Promotion {
  _id: string;
  rewardBy: string;
  rewardAmount: number;
  couponCode: string;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  targetUser: number;
  sentNumTargetUser: number;
  repeatReward: boolean;
  usesPerCoupon: string;
  comments: string;
  status: boolean;
  minimumCartValue: string;
  discountType: string;
  usesPerPlayer: number;
  promotionName: string;
  promotionDetails: string;
  image: string;
  lotteryId: string;
  usedPromotionUser: any[]; // Adjust the type if necessary
  createdAt: string;
  updatedAt: string;
}

export default function PromotionFreeTicket() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [buyPromotion, setPromotion] = useState<PromotionResponse | null>(null);

  console.log(buyPromotion, "buyPromotion");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const limit = 10;
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    getData();
  }, [page]);
  const getData = async () => {
    setLoading(true);
    let token = storage.getToken();
    try {
      let response = await axios.get(
        `${process.env.API_URL_PREFIX}/api/v1/admin/buyPromotionList`,
        {
          params: { page, limit },
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      console.log(response, "response");
      setPromotion(response?.data);
    } catch (error) {
      console.log("token error", error);
    } finally {
      setLoading(false);
    }
  };
  const auth = useAuth();
  const gridItem = {};
   if (buyPromotion?.data?.length === 0) {
    return (
      <Box
        className="w-full h-48 flex justify-center items-center"
        sx={{
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          border: "none",
          marginTop: "90px",
          minHeight: "calc(100vh - 330px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "@media screen and (max-width:992px)": {
            marginTop: "66px",
          },
        }}
      >
        <img src="/Comp_1.gif" alt="comingsoon" />
      </Box>
    );
  }

  return (
    <>
      {auth.user ? null : <HeaderValue />}
      <Box
        sx={{
          background: `linear-gradient(89.41deg, #1B1C2D 7.81%, rgba(27, 28, 45, 0) 38.09%), linear-gradient(1.53deg, #1B1C2D 13.32%, rgba(27, 28, 45, 0) 50.41%), linear-gradient(46.49deg, #1B1C2D 14.7%, rgba(27, 28, 45, 0) 43.39%), url(${HomeScreenImg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          minHeight: "100%",
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
          padding: {
            xs: "10px 0",
            lg: "100px 0px 20px",
          },
        }}
      >
        <Box
          sx={{
            // backgroundColor: "rgba(5, 5, 24, 0.8)",
            borderRadius: "10px",
            maxWidth: "95%",
            margin: "0 auto",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "768px",
              margin: "0 auto",
              textAlign: "center",
              fontFamily: '"Ubuntu", sans-serif',
              fontSize: "25px",
              lineHeight: "1.5",
            }}
          >
            <Typography
              component="h4"
              sx={{
                textTransform: "capitalize",
                fontWeight: "500 !important",
                marginBottom: { xs: "10px", md: "15px" },
                fontSize: { xs: "18px", md: "18px", lg: "22px" },
              }}
            >
              Promotions
            </Typography>
          </Box>
          <Box
            sx={{
              padding: { lg: "40px ", xs: "20px 10px 20px" },
              backgroundColor: "rgb(95 95 95 / 80%)",
              borderRadius: "10px",
              mt: "0px",
              maxWidth: "1700px",
              marginInline: "auto",
            }}
          >
            <Grid
              container
              justifyContent="start"
              spacing={{ xs: 0.5, sm: 1, md: 2, lg: 3 }}
            >
              {loading ? (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100vh"
                  width="100%"
                >
                  <CircularProgress />
                </Box>
              ) : (
                buyPromotion?.data?.map((card, index) => (
                  <Grid
                    item
                    key={index}
                    xs={6}
                    sm={3}
                    md={3}
                    lg={3}
                    className="inner-grid"
                    style={gridItem}
                  >
                    <Card
                      sx={{
                        width: "100%",
                        maxWidth: " 100%",
                        height: "100%",
                        alignItems: "center",
                      }}
                      className={classes.cardRoot}
                      onClick={() =>
                        // console.log( `/app/Lotteries/${
                        //     card?.lotteryId
                        //   }?redeemCode=${card?.couponCode.trim()}&freeTicketAmt=${
                        //     card?.rewardAmount
                        //   }&CouponId=${card?._id}` , "abhay")
                        navigate(
                          `/app/Lotteries/${card?.lotteryId
                          }?redeemCode=${card?.couponCode.trim()}&freeTicketAmt=${card?.rewardAmount
                          }&CouponId=${card?._id}`
                        )
                      }
                    >
                      <CardMedia
                        sx={{
                          height: "auto",
                          objectFit: "cover",
                          minHeight: "150px",
                          background: "rgba(75, 75, 75, 0.8)",
                        }}
                        component="img"
                        image={
                          card?.image
                            ? `${process.env.API_URL_PREFIX}/api/v1/admin/uploads/${card.image}`
                            : promotionCard
                        }
                      />
                      <CardContent
                        sx={{
                          padding: {
                            xs: "8px 8px",
                            sm: "8px 9px",
                            lg: "10px 20px",
                          },
                        }}
                      >
                        <Grid
                          container
                          spacing={{ xs: 0.5, md: 2 }}
                          justifyContent={"space-between"}
                        >
                          <Grid item xs={"auto"}>
                            <Typography
                              variant="caption"
                              sx={{
                                color: "#FFFFFF",
                                opacity: 0.5,
                                fontSize: {
                                  xs: "10px",
                                  md: "12px",
                                  lg: "12px",
                                },
                                whiteSpace: "nowrap",
                              }}
                            >
                              Reward amount:
                            </Typography>
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 700,
                                fontSize: {
                                  xs: "10px",
                                  md: "12px",
                                  lg: "14px",
                                },
                              }}
                            >
                              {card?.rewardAmount}
                            </Typography>
                          </Grid>
                          <Grid item xs={"auto"} sx={{ textAlign: "right" }}>
                            <Typography
                              variant="caption"
                              sx={{
                                color: "#FFFFFF",
                                opacity: 0.5,
                                fontSize: {
                                  xs: "10px",
                                  md: "12px",
                                  lg: "12px",
                                },
                                whiteSpace: "nowrap",
                              }}
                            >
                              Coupon code:
                            </Typography>
                            <Typography
                              variant="h3"
                              sx={{
                                opacity: 0.6,
                                fontSize: {
                                  xs: "10px",
                                  md: "12px",
                                  lg: "14px",
                                },
                              }}
                            >
                              {card?.couponCode}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Typography
                          variant="caption"
                          sx={{
                            color: "#FFFFFF",
                            opacity: 0.5,
                            fontSize: { xs: "10px", md: "12px", lg: "12px" },
                            whiteSpace: "nowrap",
                          }}
                        >
                          Description:
                        </Typography>
                        <Typography
                          variant="h3"
                          sx={{
                            opacity: 0.6,
                            fontSize: { xs: "10px", md: "12px", lg: "14px" },
                          }}
                        >
                          {card?.comments}
                        </Typography>
                      </CardContent>

                      <CardActions sx={{ p: 0 }}>
                        <LinearProgress variant="determinate" value={10} />
                      </CardActions>
                    </Card>
                  </Grid>
                ))
              )}
            </Grid>
          </Box>
          <Box display="flex" justifyContent="center" marginTop="30px">
            <Pagination
              count={buyPromotion?.pagination?.totalPages ?? 0}
              page={page}
              onChange={handlePageChange}
              color="primary"
              sx={{
                "& .MuiPaginationItem-root": {
                  color: "white",
                  fontSize: "18px",
                },
                "& .MuiPaginationItem-page.Mui-selected": {
                  backgroundColor: "primary",
                  color: "white",
                  fontSize: "25px",
                },
              }}
            />
          </Box>
        </Box>
      </Box>
      {auth.user ? null : <Footer />}
    </>
  );
}
